import { useIsNetvisorIntegrationEnabledQuery } from 'store/api/netvisor-integration';
import { useIsWintimeIntegrationEnabledQuery } from 'store/api/wintime-integration';

/** A failed flag query leaves expense entry available, so a flag outage never blocks booking an expense. */
export const useExpenseEntryDisabled = (): boolean => {
    const { data: isNetvisorEnabled, isLoading: isNetvisorLoading } = useIsNetvisorIntegrationEnabledQuery();
    const { data: isWintimeEnabled, isLoading: isWintimeLoading } = useIsWintimeIntegrationEnabledQuery();

    const isLoading = isNetvisorLoading || isWintimeLoading;

    return !isLoading && (isNetvisorEnabled === true || isWintimeEnabled === true);
};
